import {MinimumValue} from "../MinimumValue";
import {sprintf} from 'sprintf-js';
import {ValidatorInterface} from "../ValidatorInterface";
import AbstractValidatorSet from "./AbstractValidatorSet";
import Length from "../../../../../source/js/shared/models/Geometry/Length";
import { MaximumValue } from "../MaximumValue";

export default class PresetDrillHoleValidatorSet extends AbstractValidatorSet {
	private readonly minHoleDiameter: Length;
	private readonly state;

	constructor( minHoleDiameter: Length, state ) {
		super();

		this.minHoleDiameter = minHoleDiameter;
		this.state = state;
	}

	getValidators(): ValidatorInterface[] {
		const { drillHole } = window.measurementSelectorVariables.i18n.validators;

		const drillHoleDiameter = ( this.state.drillHoleDiameter instanceof Length ) ? this.state.drillHoleDiameter.in_cm() : this.state.drillHoleDiameter;

		return [
			new MinimumValue( {
				field: 'drillHoleDiameter',
				dimension: 'drillHoleDiameter',
				value: drillHoleDiameter,
				minimum: this.minHoleDiameter.in_mm(),
				customMessage: sprintf( drillHole.diameter.min, this.minHoleDiameter.in_cm_i18n() )
			} ),
			new MaximumValue( {
				field: 'drillHoleDiameter',
				dimension: 'drillHoleDiameter',
				value: drillHoleDiameter,
				maximum: this.state.drillHoleEdgeMaxDistance,
				customMessage: sprintf( drillHole.diameter.max, new Length( this.state.drillHoleEdgeMaxDistance ).in_cm_i18n() )
			} ),
		];
	}
}
